import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/bom-allocations.mdx";

export function BomAllocationsHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
